var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var SearchHitDto = (function () {
    function SearchHitDto(imageUrl, title, link, id, orderable, backInStockNotificationEnabled, comingSoonEnabled, backInStockNotificationStart, backInStockNotificationUntil, isVariant, isVariationGroup, reviewAverage, master, price, variantData, defaultVariantId, primaryCategoryId, folderId) {
        if (imageUrl === void 0) { imageUrl = ''; }
        if (title === void 0) { title = ''; }
        if (link === void 0) { link = ''; }
        if (id === void 0) { id = ''; }
        if (orderable === void 0) { orderable = false; }
        if (isVariant === void 0) { isVariant = false; }
        if (isVariationGroup === void 0) { isVariationGroup = false; }
        if (reviewAverage === void 0) { reviewAverage = 0; }
        this.imageUrl = imageUrl;
        this.title = title;
        this.link = link;
        this.id = id;
        this.orderable = orderable;
        this.backInStockNotificationEnabled = backInStockNotificationEnabled;
        this.comingSoonEnabled = comingSoonEnabled;
        this.backInStockNotificationStart = backInStockNotificationStart;
        this.backInStockNotificationUntil = backInStockNotificationUntil;
        this.isVariant = isVariant;
        this.isVariationGroup = isVariationGroup;
        this.reviewAverage = reviewAverage;
        this.master = master;
        this.price = price;
        this.variantData = variantData;
        this.defaultVariantId = defaultVariantId;
        this.primaryCategoryId = primaryCategoryId;
        this.folderId = folderId;
    }
    SearchHitDto.fromOcapi = function (ocapiResponse, isProduct) {
        if (isProduct === void 0) { isProduct = false; }
        var _a;
        var object = [
            isProduct ? ocapiResponse.c_mainImage : ocapiResponse.c_BlogLinkArticleFeaturedMedia,
            isProduct ? ocapiResponse.product_name : ocapiResponse.name,
            isProduct ? ocapiResponse.link : ocapiResponse.c_BlogLinkAssetUrl,
            isProduct ? ocapiResponse.product_id : ocapiResponse.id,
            isProduct ? ocapiResponse.orderable : false,
            isProduct ? ocapiResponse.c_bisnEnabled : void 0,
            isProduct ? ocapiResponse.c_comingSoon : void 0,
            isProduct ? ocapiResponse.c_bisnStart : void 0,
            isProduct ? ocapiResponse.c_bisnUntil : void 0,
            isProduct ? (_a = ocapiResponse.product_type) === null || _a === void 0 ? void 0 : _a.variant : false,
            isProduct ? ocapiResponse.isVariationGroup : void 0,
            isProduct ? ocapiResponse.c_reviewAverage : void 0,
            isProduct ? ocapiResponse.master : void 0,
            isProduct ? ocapiResponse.c_setTotalPrice ? ocapiResponse.c_setTotalPrice : ocapiResponse.price : void 0,
            isProduct ? ocapiResponse.c_variantData : void 0,
            isProduct ? ocapiResponse.c_defaultVariantId : void 0,
            isProduct ? ocapiResponse.c_primary_category_id : void 0,
            isProduct ? void 0 : ocapiResponse.c_BlogLinkFolderID,
        ];
        return new (SearchHitDto.bind.apply(SearchHitDto, __spreadArrays([void 0], object)))();
    };
    return SearchHitDto;
}());
export { SearchHitDto };
//# sourceMappingURL=SearchHitDto.js.map